/* AstaLab 2.0 — unico entrypoint eseguibile, condiviso fra il bundle del
   deploy reale e il bundle Artifact (build/bundle-real.mjs e
   build/bundle-artifact.mjs puntano entrambi qui). Nessuna differenza di
   codice fra i due: la differenza è SOLO nel processo di build (vedi
   quei due file) e in cosa window.__ASTALAB_ENV__ contiene a runtime. */
import { mountApp } from "./app.js";

function boot(){
  const root = document.getElementById("root");
  mountApp(root).catch(err => {
    root.innerHTML = '<p style="color:#c23f52; padding:20px;">Errore di avvio: ' +
      String(err && err.message ? err.message : err) + "</p>";
    // eslint-disable-next-line no-console
    console.error(err);
  });
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
